import axios from "axios";
import ReactGA from "react-ga";
export const GET = "GET";
export const POST = "POST";
export const PATCH = "PATCH";
export const DELETE = "DELETE";
function APICaller(method, url, data,retry = 0) {
  let start = Date.now();
  return axios({
      method,
      url,
      data,
      timeout: 10000,
    })
      .then((response) => {
        ReactGA.timing({
          category: 'API Success',
          variable: url,
          value: Date.now() - start,
          label:JSON.stringify(data),
        });
        return response.data;
      })
      .catch((error) => {
        ReactGA.timing({
          category: 'API Failure',
          variable: url,
          value: Date.now() - start,
          label:JSON.stringify(data),
        });
        if(retry === 5){
          if(error.message.includes("timeout")){
            throw {message:"Request Timed Out"}
          }
          throw error;
        }
        else{
          return APICaller(method,url,data,retry+1)
        }
      });
   
}

export default APICaller;
